import React, { RefObject } from 'react';
import { FlexBox, Text } from '@eltoro-ui/components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStars } from '@fortawesome/pro-solid-svg-icons';

type TextAreaProps = {
  textAreaRef: RefObject<any>;
  promptValue: string;
  setPromptValue: (value: React.SetStateAction<string>) => void;
  onEnter?: (event: React.KeyboardEvent<HTMLTextAreaElement>) => void;
};
const TextArea = ({ textAreaRef, promptValue, setPromptValue, onEnter }: TextAreaProps) => {
  return (
    <>
      <FlexBox gap="8px" alignItems="center">
        <FontAwesomeIcon icon={faStars} color="#007B94" style={{ fontSize: '16px' }} />
        <Text on="white" weight="bold" UNSAFE_style={{ color: '#007B94' }}>
          Ask AI
        </Text>
      </FlexBox>
      <textarea
        ref={textAreaRef}
        className="prompts__textarea"
        name="prompts"
        id="prompts"
        value={promptValue}
        rows={2}
        disabled={false}
        placeholder="Ask me anything"
        onChange={e => {
          setPromptValue(e.target.value);
        }}
        onKeyDown={onEnter}
      />
    </>
  );
};

export default TextArea;
